import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * The physician's research articles URL, which returns one page of the list as HTML.
   *
   * @type {String}
   */
  endpoint: { type: String, required: true },
  /**
   * Shows every article on the page at once, with no "Show more" toggle.
   *
   * @type {Boolean|String}
   */
  expanded: booleanAttribute(),
  /**
   * Text of the anchor bar link for this section. The link is shown while the physician has
   * articles and removed from the bar while they have none.
   *
   * @type {String}
   */
  anchorTab: { type: String, default: undefined },
});
